import { FloorPlanMemoText } from "~/_legacy/types/analysis";
import { FloorPlanMemoTextResponse } from "~/_legacy/types/api";
import axiosInstance from "./axios-instance";

const createApiUrl = (branchUid: string, floorPlanId: number) =>
  `branches/${branchUid}/floor-plans/${floorPlanId}/texts/`;

export const fetchFloorPlanMemoTexts = async ({
  branchUid,
  branchVersionId,
  floorPlanId,
}: {
  branchUid: string;
  branchVersionId?: number;
  floorPlanId: number;
}) => {
  const url = createApiUrl(branchUid, floorPlanId);
  const { data } = await axiosInstance.get<FloorPlanMemoTextResponse[]>(url, {
    params: {
      version: branchVersionId,
    },
  });

  const converted: FloorPlanMemoText[] = data.map((memoText) => ({
    id: memoText.id,
    floorPlanId: memoText.floor_plan_id,
    content: memoText.content,
    style: {
      color: memoText.style.color,
      width: memoText.style.width,
      opacity: memoText.style.opacity,
      fontSize: memoText.style.font_size,
      hasStroke: memoText.style.has_stroke,
      ...(memoText.style.rotation != null && { rotation: memoText.style.rotation }),
    },
    position: memoText.position,
  }));

  return converted;
};
